import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import image1 from '../assets/about/image1.jpeg';
import './Main.css';

const About = () => {
    const navigate = useNavigate();
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
    const handleResize = () => {
        setSize({
        width: window.innerWidth,
        height: window.innerHeight,
        });
    };

    window.addEventListener('resize', handleResize);

    // 컴포넌트 언마운트 시 이벤트 제거
    return () => window.removeEventListener('resize', handleResize);
    }, []);

    const goToGallery = () => {
        navigate('/pages/gallery')
    }

    const goToAbout = () => {
        navigate('/pages/about')
    }

    const goToContact = () => {
        navigate('/pages/contact')
    }

    return(
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", padding: "0px 8px",}}>
            {size.width > 768 && 
            <div style={{display: "flex", justifyContent: "center", gap: 32, marginBottom: 96}}>
                <div onClick={goToGallery} className="nav-item">GALLERY</div>
                <div onClick={goToAbout} className="nav-item">ABOUT</div>
                <div onClick={goToContact} className="nav-item">CONTACT</div>
            </div>}
            <div style={{fontSize: 42, fontWeight: 300, marginBottom: 64}}>
                우리의 공간을 위한 선택,
            </div>
            <img src={image1} style={{width: size.width <= 1280 ? size.width - 16 : 1280, height: "auto"}} />
            <div style={{width: size.width <= 1280 ? size.width - 16 : 1280, display: "flex", textAlign: "center", fontSize: 16, fontWeight: 400, lineHeight: 2, marginTop: 64, marginBottom: 16}}>
                Clean all areas except the exterior window. We also provide interpretation services for foreigners. We respect various payment methods, such as cards and cash, depending on the situation.  In addition, you can reduce the price of use by excluding unnecessary options. The unit price is two dollars and it's per pyeong. The method of simulating the amount of use is the amount of space that needs to be cleaned multiplied by $2 dollars. Depending on the conditions of the site, it can be measured a little more expensive or cheaper.  You can work even if it's not a normal cleaning because it's restoring old windows or there's a lot of trash. The amount of use is a method of visiting the site in advance, looking around and delivering it, and payment will be made immediately after viewing the results of the work on the day of the work. 
            </div>
            <div style={{width: size.width <= 1280 ? size.width - 16 : 1280, height: 1, backgroundColor: '#E2E5E8'}} />
        </div>
    )
}

export default About;